import { render, staticRenderFns } from "./MonthlyLoanPerformance.vue?vue&type=template&id=4cb94bca&scoped=true&"
import script from "./MonthlyLoanPerformance.vue?vue&type=script&lang=js&"
export * from "./MonthlyLoanPerformance.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyLoanPerformance.vue?vue&type=style&index=0&id=4cb94bca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb94bca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
